module.exports = __webpack_public_path__ + "static/media/BBQ_Showdown.f4994c89.png";